import { render, staticRenderFns } from "./PositionEditComponent.vue?vue&type=template&id=6e1f95f5"
import script from "./PositionEditComponent.vue?vue&type=script&lang=js"
export * from "./PositionEditComponent.vue?vue&type=script&lang=js"
import style0 from "./PositionEditComponent.vue?vue&type=style&index=0&id=6e1f95f5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports